import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatState} from 'api/types'

export const accessCreated: CaseReducer<NinchatState> = (state) => state
